import Icon from '../components/Icon.vue'

Icon.register({"spoon":{"width":768,"height":1792,"paths":[{"d":"M704 528q0 145-57 243.5t-152 135.5l45 821q2 26-16 45t-44 19h-192q-26 0-44-19t-16-45l45-821q-95-37-152-135.5t-57-243.5q0-128 42.5-249.5t117.5-200 160-78.5 160 78.5 117.5 200 42.5 249.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/spoon.js
// module id = 8KVq
// module chunks = 0